import { render, staticRenderFns } from "./ByVisit.vue?vue&type=template&id=b850408e&"
import script from "./ByVisit.vue?vue&type=script&lang=js&"
export * from "./ByVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports